import { ComponentDataSourceService } from '../../component-data-source.service';
import { Observable, shareReplay } from 'rxjs';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';
import { EventDTO } from '../../../../dto/event/event.dto';
import { Router } from '@angular/router';

export const event = (service: ComponentDataSourceService): DataSourceFunction => ({
  name: 'event',
  description: 'Get full event data including all participants',
  execute: (params?: LoadDataParams): Observable<EventDTO> => {
    const router = service.injector.get(Router);
    const pathSegments = router.url.split('/');
    const eventGuid = pathSegments.find(segment => 
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)
    );
    
    if (!eventGuid) {
      throw new Error('No valid event GUID found in URL');
    }

    return service.http.get<EventDTO>(`${environment.apiUrl}/events/${eventGuid}`).pipe(
      shareReplay(1) // Share the response between all subscribers
    );
  }
}); 